import React from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
// import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
// import { IMatch } from "../../types";
import Link from "../link";
import { injectIntl } from "react-intl";
import messages from "./PageViewExercise.intl";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      justifyContent: "center",
      flexWrap: "wrap",
      marginTop: theme.spacing(2),
    },
    paper: {
      padding: theme.spacing(1, 2),
    },
  })
);

const Breadcrumb = injectIntl<{ exercise: any }>(({ exercise, intl }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Paper elevation={0} className={classes.paper}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link color="inherit" to="/library">
            {intl.formatMessage(messages.library)}
          </Link>
          <Link color="inherit" to={`/library?category=${exercise.category}`}>
            {exercise.category}
          </Link>
          <Link
            color="inherit"
            to={`/library?subcategory=${exercise.subcategory}`}
          >
            {exercise.subcategory}
          </Link>

          {/* <Typography color="textPrimary">{exercise.category}</Typography> */}
        </Breadcrumbs>
      </Paper>
      <br />
    </div>
  );
});

export default Breadcrumb;
